module.exports = __webpack_public_path__ + "media/application/images/projects/images/canada_ice-6c4330da7972dc6bb3b868f6fafae610.jpg";